var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSalaryIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "credit_card_24px"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon/action/credit_card_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6665 3.33331H3.33317C2.40817 3.33331 1.67484 4.07498 1.67484 4.99998L1.6665 15C1.6665 15.925 2.40817 16.6666 3.33317 16.6666H16.6665C17.5915 16.6666 18.3332 15.925 18.3332 15V4.99998C18.3332 4.07498 17.5915 3.33331 16.6665 3.33331ZM16.6665 15H3.33317V9.99998H16.6665V15ZM3.33317 6.66665H16.6665V4.99998H3.33317V6.66665Z",
  fill: "#4E6072"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSalaryIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/salary-icon.5624f05c.svg";
export { ForwardRef as ReactComponent };